module.exports = __webpack_public_path__ + "static/img/success-addwx.a51acb44.png";